function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F4F3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 21C5.83 21 5.66 20.957 5.507 20.87C5.194 20.693 5 20.36 5 20V5.333C5 4.047 5.987 3 7.2 3H16.8C18.013 3 19 4.047 19 5.333V20C19 20.355 18.811 20.685 18.504 20.864C18.197 21.044 17.818 21.046 17.508 20.871L11.836 17.663L6.515 20.857C6.356 20.952 6.178 21 6 21Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 21C5.83 21 5.66 20.957 5.507 20.87C5.194 20.693 5 20.36 5 20V5.333C5 4.047 5.987 3 7.2 3H16.8C18.013 3 19 4.047 19 5.333V20C19 20.355 18.811 20.685 18.504 20.864C18.197 21.044 17.818 21.046 17.508 20.871L11.836 17.663L6.515 20.857C6.356 20.952 6.178 21 6 21",
  stroke: "currentColor",
  strokeWidth: 2
});

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.e1b1ba79.svg";
export { ForwardRef as ReactComponent };